import React from 'react'

interface IProps {
  labelName: string
}

const FormLabel = ({ labelName }: IProps) => {
  return (
    <div className="md:whitespace-nowrap text-base font-medium text-gray-900 lg:mt-2">
      {labelName}
    </div>
  )
}

export default FormLabel
